import svg4everybody from 'svg4everybody';
import toggleGrid from './lib/toggleGrid';
import isTouch from './lib/detectTouch';
import {CLASSES, DOM, BREAKPOINTS} from './constants';
import {stickyHeader, initMenu} from './components/header';
import './components/sliders';
import './components/scrollAnimations';
import './components/lottie';
import './form/select';
import './form/textarea';
import './posts';


const {$body, $window, $claimText, $claim} = DOM;

toggleGrid();
const checkIsTouch = () => {
  const { touch, noTouch } = CLASSES;
  if (isTouch()) {
    $body.addClass(touch);
  } else {
    $body.addClass(noTouch);
  }
};

const stickyClaim = () => {
  if ($window.scrollTop() > $claim.height() - $window.height()) {
    $claimText.removeClass(CLASSES.fixed);
  } else {
    $claimText.addClass(CLASSES.fixed);
  }
};

const lineParallax = () => {
  const $line = $('.hero__v-line');
  $line && $line.css('transform', `translateY(${-$window.scrollTop()/2 + 150}px)`);
};

const scrollFunctions = () => {
  stickyHeader();
  stickyClaim();
  lineParallax();
};

const focusInput = () => {
  const $input = $('.input__field');

  $input.focus(function() {
    const $parent = $(this).parents('.input');
    $parent.addClass(CLASSES.focus);
  });

  $input.blur(function() {
    const $parent = $(this).parents('.input');
    $parent.removeClass(CLASSES.focus);
  });

  $input.on('input', function(e) {
    const $parent = $(this).parents('.input');
    if (e.currentTarget.value) {
      $parent.addClass(CLASSES.filled);
    } else {
      $parent.removeClass(CLASSES.filled);
    }
  });
};

const handleWinReady = () => {
  checkIsTouch();
  svg4everybody();
  initMenu();
  stickyHeader();
  stickyClaim();
  focusInput();
  $window.scroll(scrollFunctions);
  $('.js-scroll-to').click(function(e) {
    e.preventDefault();
    const aid = $(this).attr('href');
    $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
  });

  $('.js-team-item-btn').click(function() {
    const $parent = $(this).parents('.js-team-item');
    $parent.toggleClass(CLASSES.active);
    if ($window.width() > BREAKPOINTS.sm) {
      $parent.find('.js-team-item-desk').slideToggle();
    } else {
      $parent.find('.js-team-item-content').slideToggle();
    }
  });
};

$window.ready(handleWinReady);
